<template>
  <div>
    <v-menu
      bottom
      offset-y
      open-on-hover
      nudge-left="120"
    >
      <template v-slot:activator="{ on }">
        <v-icon
          class="settingIcon"
          color="metalGreyDark"
          v-on="on"
        >
          mdi-cog
        </v-icon>
      </template>

      <v-list>
        <v-list-tile
          class="menuItem"
          @click="passwordChangeDialog = true"
        >
          <v-icon
            color="black"
            class="mr-2"
          >
            mdi-lock-open
          </v-icon>
          パスワード変更
        </v-list-tile>
        <v-list-tile
          class="menuItem"
          style="color:red"
          @click="deleteUserDialog = true"
        >
          <v-icon
            class="mr-2"
            color="error"
          >
            mdi-account-minus
          </v-icon>
          ユーザー削除
        </v-list-tile>
      </v-list>
    </v-menu>

    <v-dialog
      v-model="passwordChangeDialog"
      max-width="500"
    >
      <PasswordUpdate
        :key="uniqueKey"
        :user-id="userId"
        @input="passwordChangeDialog = $event"
      />
    </v-dialog>
    <ConfirmDialog
      v-model="deleteUserDialog"
      :loading="loading"
      @confirm="deleteUserHandler"
      @cancel="deleteUserDialog = false"
    >
      管理番号: {{ userId }} のユーザーを削除しますか？<br>
      （この操作はやり直しできません。）
      <div
        v-if="errorMessage"
        class="error-message mt-3 px-1"
      >
        削除できませんでした。<br>
        ・{{ errorMessage }}
      </div>
    </ConfirmDialog>
  </div>
</template>

<script>
import { api } from '@/api.js'
import { ConfirmDialog } from '@/components/dialog'

export default {
  name: 'Settings',
  components: {
    ConfirmDialog,
    PasswordUpdate: () => import('./PasswordUpdate')
  },
  props: {
    userId: {
      type: Number,
      required: true
    },
    userName: {
      type: String,
      default: () => ''
    }
  },
  data () {
    return {
      passwordChangeDialog: false,
      deleteUserDialog: false,
      errorMessage: '',
      loading: false,
      uniqueKey: 0
    }
  },
  watch: {
    passwordChangeDialog (val) {
      if (!val) this.uniqueKey++
    }
  },
  methods: {
    async deleteUserHandler () {
      this.loading = true
      try {
        await api.deleteUser(this.userId)
        this.$emit('user-deleted')
        this.$store.commit('app/setGlobalSnackBarText', `ユーザー（${this.userName}さん）を削除しました。`)
        this.deleteUserDialog = false
      } catch (err) {
        this.errorMessage = err.response?.body?.errorMessage
          ? err.response.body.errorMessage
          : 'エラーにより削除できませんでした。'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .menuItem{
    cursor: pointer;
    &:hover{
      background: rgba(0, 0, 0, 0.021);
    }
  }
  .settingIcon{
    position: absolute;
    right: -10px;
    cursor: pointer;
  }
  .error-message {
    color: red;
    font-size: 0.8rem;
    width: 100%;
  }
</style>
